
export const ar = {
  nav: {
    home: 'الرئيسية',
    about: 'من نحن',
    services: 'الخدمات',
    blog: 'المدونة',
    contact: 'اتصل بنا',
    language: 'اللغة'
  },
  header: {
    search: 'البحث...',
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    logout: 'تسجيل الخروج',
    account: 'الحساب'
  },
  auth: {
    login: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    fullName: 'الاسم الكامل',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    confirmPassword: 'تأكيد كلمة المرور',
    enterFullName: 'أدخل اسمك الكامل',
    enterEmail: 'أدخل عنوان بريدك الإلكتروني',
    enterPassword: 'أدخل كلمة المرور',
    confirmPasswordPlaceholder: 'أكد كلمة المرور',
    loginButton: 'تسجيل الدخول',
    registerButton: 'إنشاء حساب',
    processing: 'جاري المعالجة...',
    noAccount: 'ليس لديك حساب؟',
    hasAccount: 'لديك حساب بالفعل؟',
    loginLink: 'تسجيل الدخول',
    registerLink: 'إنشاء حساب',
    passwordMismatch: 'كلمات المرور غير متطابقة',
    passwordTooShort: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
    invalidCredentials: 'بريد إلكتروني أو كلمة مرور غير صحيحة',
    emailExists: 'عنوان البريد الإلكتروني هذا مستخدم بالفعل',
    generalError: 'حدث خطأ، يرجى المحاولة مرة أخرى'
  },
  hero: {
    title: 'طور مسيرتك المهنية بالشهادات المهنية',
    subtitle: 'احصل على شهادات معترف بها دولياً مع IQCERT واصنع الفرق في عالم الأعمال. حقق النجاح مع مدربينا الخبراء وبرامجنا التدريبية عالية الجودة.',
    cta: 'تصفح الشهادات',
    watchVideo: 'شاهد الفيديو التعريفي'
  },

  // Navigation
  "nav.home": "الرئيسية",
  "nav.about": "من نحن",
  "nav.services": "الخدمات",
  "nav.blog": "المدونة",
  "nav.contact": "اتصل بنا",
  "nav.language": "اللغة",

  // Hero Section
  "hero.title": "التدريب المهني للحصول على الشهادات",
  "hero.subtitle": "احصل على الشهادات التي تحتاجها لتطوير مسيرتك المهنية",
  "hero.description": "طور مهاراتك من خلال برامج الشهادات عبر الإنترنت من المدربين الخبراء واصنع الفرق في مسيرتك المهنية.",
  "hero.cta": "استكشف الدورات",
  "hero.watch": "شاهد الفيديو التعريفي",

  // Services Section
  "services.title": "برامج الشهادات",
  "services.subtitle": "تدريب عالي الجودة من مدربين خبراء في مجالهم",
  "services.it.title": "تكنولوجيا المعلومات",
  "services.it.description": "برامج شهادات مهنية في تطوير البرمجيات وتحليل البيانات والأمن السيبراني.",
  "services.business.title": "إدارة الأعمال",
  "services.business.description": "برامج شهادات من مدربين خبراء في إدارة المشاريع والقيادة وتطوير الأعمال.",
  "services.design.title": "التصميم والإبداع",
  "services.design.description": "برامج شهادات إبداعية في التصميم الجرافيكي وواجهة المستخدم والتسويق الرقمي.",
  "services.language.title": "التدريب اللغوي",
  "services.language.description": "برامج شهادات معترف بها دولياً في الإنجليزية والألمانية واللغات الأجنبية الأخرى",

  // About Section
  "about.title": "لماذا تختارنا؟",
  "about.subtitle": "لقد منحنا الشهادات لآلاف الطلاب بخبرة تزيد عن 10 سنوات",
  "about.expert.title": "مدربون خبراء",
  "about.expert.description": "احصل على تعليم عالي الجودة من مدربين ذوي خبرة ومعتمدين",
  "about.flexible.title": "تعلم مرن",
  "about.flexible.description": "انضم للتدريب بوتيرتك الخاصة، في أي وقت ومن أي مكان",
  "about.certificate.title": "شهادات معتمدة",
  "about.certificate.description": "عزز مسيرتك المهنية بشهادات معترف بها دولياً",
  "about.support.title": "دعم 24/7",
  "about.support.description": "نحن معك دائماً خلال عملية التعلم",
  "about.tagline": "شهادات IQCERT",
  "about.certificates.badge": "شهادات معترف بها دولياً",
  "about.certificates.badgeDesc": "ISO 9001، ISO 14001، HACCP، SCC والمزيد",

  // Blog Section
  "blog.title": "أحدث المقالات",
  "blog.subtitle": "محتوى حديث حول التعليم وتطوير المهنة",
  "blog.readMore": "اقرأ المزيد",
  "blog.post1.title": "أهمية التدريب على الشهادات في العصر الرقمي",
  "blog.post1.excerpt": "في عصر التكنولوجيا سريعة التطور اليوم، لم يعد التعلم المستمر وتحسين الذات رفاهية، بل ضرورة.",
  "blog.post1.author": "د. محمد يلماز",
  "blog.post1.date": "15 ديسمبر 2024",
  "blog.post1.category": "التعليم",
  "blog.post2.title": "دور الشهادات في تطوير المهنة",
  "blog.post2.excerpt": "ما هي الشهادات التي يجب أن تحصل عليها للتميز في عالم الأعمال؟ نصائح الخبراء وقصص النجاح.",
  "blog.post2.author": "عائشة ديمير",
  "blog.post2.date": "12 ديسمبر 2024",
  "blog.post2.category": "المهنة",
  "blog.post3.title": "10 نصائح للنجاح في التعليم عبر الإنترنت",
  "blog.post3.excerpt": "الاستراتيجيات والتوصيات التي يجب تطبيقها للحصول على أقصى كفاءة من التدريب عبر الإنترنت.",
  "blog.post3.author": "أ.د. علي كايا",
  "blog.post3.date": "10 ديسمبر 2024",
  "blog.post3.category": "نصائح",

  // News Section
  "news.title": "الأخبار والإعلانات",
  "news.subtitle": "آخر الأخبار من الصناعة والإعلانات المهمة",

  // Info Banners
  "info.students": "الطلاب النشطون",
  "info.courses": "برامج الشهادات",
  "info.instructors": "المدربون الخبراء",
  "info.satisfaction": "معدل الرضا",

  // Footer
  "footer.description": "طور مسيرتك المهنية مع التدريب المهني للحصول على الشهادات",
  "footer.quickLinks": "روابط سريعة",
  "footer.programs": "البرامج",
  "footer.support": "الدعم",
  "footer.contact": "اتصل بنا",
  "footer.phone": "الهاتف",
  "footer.email": "البريد الإلكتروني",
  "footer.address": "العنوان",
  "footer.rights": "جميع الحقوق محفوظة",

  // Common
  "common.learnMore": "تعلم المزيد",
  "common.getStarted": "ابدأ",
  "common.viewAll": "عرض الكل",
  "common.loading": "جاري التحميل...",
  "common.error": "حدث خطأ",
  "common.success": "نجح",

  // Services Pages
  "services.belgelendirme.title": "خدمات التصديق",
  "services.belgelendirme.subtitle": "السياحة المستدامة، شهادة GSTC، تصديق الموظفين والنباتيين",
  "services.belgelendirme.description": "كشركة IQCERT، نقدم خدمات التصديق وفقاً للمعايير الدولية في قطاعات مختلفة. نخدم بفريقنا الخبير في السياحة المستدامة وكفاءات الموظفين ومجالات التصديق الخاصة.",
  "services.belgelendirme.sustainable": "السياحة المستدامة",
  "services.belgelendirme.gstc": "شهادة GSTC",
  "services.belgelendirme.personnel": "تصديق الموظفين",
  "services.belgelendirme.vegan": "التصديق النباتي",

  "services.yonetim.title": "تصديق أنظمة الإدارة",
  "services.yonetim.subtitle": "معايير ISO وخدمات تصديق أنظمة الإدارة",
  "services.yonetim.description": "نقدم خدمات التصديق وفقاً لمعايير ISO في مجالات مثل الجودة والبيئة والصحة والسلامة المهنية وإدارة الطاقة.",
  "services.yonetim.iso9001": "ISO 9001 نظام إدارة الجودة",
  "services.yonetim.iso14001": "ISO 14001 نظام الإدارة البيئية",
  "services.yonetim.iso45001": "ISO 45001 الصحة والسلامة المهنية",
  "services.yonetim.iso50001": "ISO 50001 نظام إدارة الطاقة",
  "services.yonetim.iso10002": "ISO 10002 إدارة رضا العملاء",
  "services.yonetim.iso27001": "ISO 27001 إدارة أمن المعلومات",
  "services.yonetim.iso27701": "ISO 27701 حماية البيانات الشخصية",
  "services.yonetim.iso31000": "ISO 31000 نظام إدارة المخاطر",
  "services.yonetim.iso39001": "ISO 39001 سلامة المرور على الطرق",
  "services.yonetim.iso28001": "ISO 28001 أمن سلسلة التوريد",
  "services.yonetim.iso22301": "ISO 22301 إدارة استمرارية الأعمال",

  // ISO Standards Details
  "iso.9001.description": "معيار نظام إدارة الجودة الذي يزيد من رضا العملاء",
  "iso.9001.benefits.1": "زيادة رضا العملاء",
  "iso.9001.benefits.2": "كفاءة العمليات",
  "iso.9001.benefits.3": "انخفاض معدلات الأخطاء",
  "iso.9001.benefits.4": "ثقافة التحسين المستمر",

  "iso.14001.description": "نظام إدارة يقلل من التأثيرات البيئية",
  "iso.14001.benefits.1": "تقليل المخاطر البيئية",
  "iso.14001.benefits.2": "توفير الطاقة",
  "iso.14001.benefits.3": "إدارة النفايات",
  "iso.14001.benefits.4": "الامتثال القانوني",

  "iso.45001.description": "نظام لحماية صحة وسلامة الموظفين",
  "iso.45001.benefits.1": "انخفاض حوادث العمل",
  "iso.45001.benefits.2": "سلامة الموظفين",
  "iso.45001.benefits.3": "تقييم المخاطر",
  "iso.45001.benefits.4": "الوفاء بالالتزامات القانونية",

  "iso.50001.description": "نظام إدارة يزيد من كفاءة الطاقة",
  "iso.50001.benefits.1": "انخفاض تكاليف الطاقة",
  "iso.50001.benefits.2": "تقليل البصمة الكربونية",
  "iso.50001.benefits.3": "تحسين أداء الطاقة",
  "iso.50001.benefits.4": "الاستدامة",

  "iso.10002.description": "نظام لإدارة شكاوى العملاء بفعالية",
  "iso.10002.benefits.1": "زيادة ولاء العملاء",
  "iso.10002.benefits.2": "عملية حل الشكاوى",
  "iso.10002.benefits.3": "تغذية راجعة من العملاء",
  "iso.10002.benefits.4": "تحسين جودة الخدمة",

  "iso.27001.description": "حماية أصول المعلومات وإدارة الأمن",
  "iso.27001.benefits.1": "أمن البيانات",
  "iso.27001.benefits.2": "الحماية من الهجمات السيبرانية",
  "iso.27001.benefits.3": "ضمان السرية",
  "iso.27001.benefits.4": "الامتثال القانوني",

  "iso.27701.description": "نظام حماية البيانات الشخصية المتوافق مع KVKK و GDPR",
  "iso.27701.benefits.1": "الامتثال لـ KVKK",
  "iso.27701.benefits.2": "أمن البيانات الشخصية",
  "iso.27701.benefits.3": "إدارة الخصوصية",
  "iso.27701.benefits.4": "تقليل المخاطر القانونية",

  "iso.31000.description": "الإدارة المنهجية للمخاطر المؤسسية",
  "iso.31000.benefits.1": "تحديد المخاطر",
  "iso.31000.benefits.2": "تقييم المخاطر",
  "iso.31000.benefits.3": "استراتيجيات تقليل المخاطر",
  "iso.31000.benefits.4": "عمليات اتخاذ القرار",

  "iso.39001.description": "نظام إدارة يزيد من سلامة المرور",
  "iso.39001.benefits.1": "انخفاض حوادث المرور",
  "iso.39001.benefits.2": "سلامة السائقين",
  "iso.39001.benefits.3": "إدارة أسطول المركبات",
  "iso.39001.benefits.4": "ثقافة السلامة",

  "iso.28001.description": "نظام إدارة أمن سلسلة التوريد",
  "iso.28001.benefits.1": "أمن التوريد",
  "iso.28001.benefits.2": "أمن اللوجستيات",
  "iso.28001.benefits.3": "إدارة المخاطر",
  "iso.28001.benefits.4": "الاستمرارية التشغيلية",

  "iso.22301.description": "نظام إدارة يضمن استمرارية الأعمال",
  "iso.22301.benefits.1": "تخطيط استمرارية الأعمال",
  "iso.22301.benefits.2": "إدارة الأزمات",
  "iso.22301.benefits.3": "المرونة التشغيلية",
  "iso.22301.benefits.4": "التعافي السريع",

  // Implementation Process
  "implementation.title": "عملية التنفيذ",
  "implementation.subtitle": "ننفذ أنظمة الإدارة الخاصة بك بنجاح من خلال نهجنا المنهجي",
  "implementation.step1.title": "تحليل الوضع الحالي",
  "implementation.step1.description": "تقييم الوضع الحالي للمنظمة وتحليل الفجوات",
  "implementation.step2.title": "تصميم النظام",
  "implementation.step2.description": "تصميم نظام الإدارة المتوافق مع معيار ISO",
  "implementation.step3.title": "التوثيق",
  "implementation.step3.description": "إعداد السياسات والإجراءات والتعليمات",
  "implementation.step4.title": "التدريب والتنفيذ",
  "implementation.step4.description": "تدريب الموظفين وتطبيق النظام",
  "implementation.step5.title": "التدقيق الداخلي",
  "implementation.step5.description": "مراقبة فعالية النظام من خلال التدقيق الداخلي",
  "implementation.step6.title": "تدقيق التصديق",
  "implementation.step6.description": "تدقيق التصديق من قبل منظمة مستقلة",

  // Why Choose ISO
  "why.iso.title": "لماذا أنظمة إدارة ISO؟",
  "why.iso.subtitle": "ارفع أداء منظمتك مع معايير ISO",
  "why.iso.recognition.title": "الاعتراف الدولي",
  "why.iso.recognition.description": "تصديق صالح في الأسواق العالمية",
  "why.iso.improvement.title": "تحسين العمليات",
  "why.iso.improvement.description": "زيادة في الكفاءة التشغيلية",
  "why.iso.risk.title": "إدارة المخاطر",
  "why.iso.risk.description": "تحديد وإدارة المخاطر بشكل استباقي",
  "why.iso.trust.title": "ثقة العملاء",
  "why.iso.trust.description": "زيادة رضا وولاء العملاء",

  // CTA Section
  "cta.iso.title": "ابدأ تطبيق نظام إدارة ISO",
  "cta.iso.description": "يساعدك مستشارونا الخبراء في تحديد معيار ISO الأنسب وتطبيقه بنجاح.",
  "cta.consultation": "استشارة مجانية",
  "cta.quote": "احصل على عرض سعر",

  // General
  "iso.standards.title": "أنظمة إدارة ISO",
  "iso.standards.subtitle": "اعد عملك للمستقبل مع أنظمة الإدارة ذات المعايير الدولية",
  "benefits.title": "الفوائد:",

  // Services Pages continued from original
  "services.teknik.title": "الفحوصات التقنية",
  "services.teknik.subtitle": "فحوصات المصاعد والسلالم المتحركة والمعدات التقنية",
  "services.teknik.description": "نقدم خدمات الفحص والمعاينة الدورية للتشغيل الآمن للمعدات التقنية.",
  "services.teknik.elevator": "الفحص الدوري للمصاعد",
  "services.teknik.escalator": "الفحص الدوري للسلالم المتحركة",
  "services.teknik.photovoltaic": "فحوصات الطاقة الشمسية",
  "services.teknik.equipment": "فحوصات معدات العمل",

  "services.denetim.title": "خدمات التدقيق والمراقبة",
  "services.denetim.subtitle": "مراقبة ما قبل التحميل، تدقيق الطرف الثاني وفحوصات النظافة",
  "services.denetim.description": "نقدم خدمات التدقيق والمراقبة الشاملة لجودة المنتج وسلامة العمليات.",
  "services.denetim.preloading": "مراقبة ما قبل التحميل",
  "services.denetim.secondparty": "تدقيق الطرف الثاني",
  "services.denetim.hygiene": "النظافة والتطهير",

  "services.enerji.title": "كفاءة الطاقة",
  "services.enerji.subtitle": "شهادة هوية الطاقة، الدراسة وخدمات الاستشارة",
  "services.enerji.description": "نقدم خدمات الاستشارة الخبيرة والتصديق في مواضيع توفير الطاقة والكفاءة.",
  "services.enerji.certificate": "شهادة هوية الطاقة",
  "services.enerji.study": "دراسة الطاقة",
  "services.enerji.consulting": "استشارة كفاءة الطاقة",
  "services.enerji.zerowaste": "إدارة عملية النفايات الصفرية",

  "services.ozel.title": "التدقيقات الخاصة",
  "services.ozel.subtitle": "تدقيقات أمان المدارس والمباني الخضراء والفنادق والرياضة",
  "services.ozel.description": "نقدم خدمات تدقيق الأمان والجودة للقطاعات الخاصة.",
  "services.ozel.school": "أمان المدارس",
  "services.ozel.green": "المبنى الأخضر",
  "services.ozel.hotel": "تدقيقات الفنادق",
  "services.ozel.sports": "أمان الرياضة",

  // Certificate Showcase
  "showcase.badge": "شهادات دولية",
  "showcase.title": "معايير التصديق المعترف بها عالمياً",
  "showcase.description": "ارفع عملك إلى المعايير العالمية بشهاداتنا الصالحة دولياً التي تشمل GMP وHACCP وISO والمزيد.",
  "showcase.point1": "ISO 9001، ISO 14001، ISO 45001 والمزيد",
  "showcase.point2": "شهادات سلامة الغذاء HACCP وGMP",
  "showcase.point3": "شهادات SCC وGSTC الدولية",
  "showcase.point4": "عملية تصديق سريعة وموثوقة",

  // Achievement Section
  "achievement.badge": "الإنجازات المؤسسية",
  "achievement.title": "الاعتراف والنجاح الدولي",
  "achievement.subtitle": "كشركة IQ CERT، نحن نقطة مرجعية موثوقة في الصناعة بإنجازاتنا واعتماداتنا في الساحة الدولية.",
  "achievement.caption": "حفل شهادة IQ PCC-PYB",
  "achievement.description": "كفاءتنا في إصدار الشهادات المعتمدة من قبل منظمات الاعتماد الدولية تمكننا من تقديم أعلى ضمان للجودة لعملائنا.",
  "achievement.caption2": "حفل شهادة جامعة زنجيزور",
  "achievement.description2": "في حفل الشهادات الذي أقيم في إطار تعاوننا الدولي، تم تقديم الشهادات المعتمدة من IQ CERT للمشاركين.",
  "achievement.caption3": "التعاون والشراكة في الحلول مع ULAK",
  "achievement.description3": "من خلال تعاوننا الاستراتيجي مع المدير العام لـ ULAK فاتح سنان يلماز، نعمل على تحسين جودة خدماتنا في معايير الاعتماد الدولية.",
  "achievement.stat1": "صلاحية الدولة",
  "achievement.stat2": "الشهادات الصادرة",
  "achievement.stat3": "سنوات الخبرة",
  "achievement.stat4": "رضا العملاء"
};

export default ar;
